import type { ResidentReportModel } from "../types/resident-report.types";

export function InterestParticipation({
  interests,
  participationGap,
}: Pick<ResidentReportModel, "interests" | "participationGap">) {
  return (
    <section className="report-card interest-participation">
      <header>
        <div>
          <p className="report-eyebrow">Interests</p>
          <h2>Interests vs participation</h2>
        </div>
      </header>
      <p>Compare stated interests with attended events</p>
      {interests.length === 0 ? (
        <p className="report-empty-state">No interest participation data available.</p>
      ) : (
        <div className="interest-participation__list">
          {interests.map((interest) => (
            <article key={interest.id}>
              <div>
                <strong>{interest.name}</strong>
                <span className={interest.isStated ? "is-stated" : ""}>
                  {interest.isStated ? "Stated" : "Not stated"}
                </span>
              </div>
              <div className="interest-participation__bar">
                <i style={{ width: `${interest.participationRate}%` }} />
              </div>
              <b>{interest.participationRate}%</b>
            </article>
          ))}
        </div>
      )}
      {participationGap ? <aside>{participationGap}</aside> : null}
    </section>
  );
}
